module.exports = __webpack_public_path__ + "static/img/charge-p1.09102ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/charge-p1.png
// module id = mQpm
// module chunks = 0